document.addEventListener('DOMContentLoaded', function () {
  // ヒーロースライダーのスライドの数のみ取得
  const slides = document.querySelectorAll('.full-screen-slider .swiper-slide');
  const navigationContainer = document.querySelector('.hero-slider__navigation');
  
  // ナビゲーションアイテムを自動生成
  function generateNavigation() {
    navigationContainer.innerHTML = ''; // 既存の内容をクリア
    
    slides.forEach((slide, index) => {
      const navItem = document.createElement('div');
      navItem.className = 'hero-nav__item';
      navItem.setAttribute('data-slide', index);
      
      navItem.innerHTML = `
        <div class="hero-nav__circle">
          <svg class="hero-nav__progress" viewBox="0 0 50 50">
            <circle class="circle-back" cx="25" cy="25" r="20" />
            <circle class="circle-front" cx="25" cy="25" r="20" />
          </svg>
          <div class="hero-nav__dot"></div>
        </div>
      `;
      
      navigationContainer.appendChild(navItem);
    });
    
    console.log(`Generated ${slides.length} navigation items`);
  }
  
  // ナビゲーション生成
  generateNavigation();
  
  // 生成後にナビゲーション要素を取得
  let navItems = document.querySelectorAll('.hero-slider__navigation .hero-nav__item');
  console.log('Found navigation items:', navItems.length);

  // 関数を先に定義
  function updateNavigation(realIndex) {
    const navItems = document.querySelectorAll('.hero-slider__navigation .hero-nav__item'); // ヒーロースライダーのナビのみ取得
    console.log('Updating navigation for realIndex:', realIndex, 'navItems length:', navItems.length);
    
    // realIndexが範囲外の場合は修正
    const validIndex = realIndex % navItems.length;
    console.log('Valid navigation index:', validIndex);
    
    navItems.forEach((item, index) => {
      if (index === validIndex) {
        item.classList.add('hero-nav__item--active');
      } else {
        item.classList.remove('hero-nav__item--active');
      }
    });
  }

  function resetAllProgress() {
    const navItems = document.querySelectorAll('.hero-slider__navigation .hero-nav__item'); // ヒーローナビのみ取得
    navItems.forEach((item) => {
      item.classList.remove('hero-nav__item--active');
    });
  }

  function startProgressAnimation(realIndex) {
    console.log('Starting animation for index:', realIndex);
    
    // realIndexが範囲外の場合は修正
    const navItems = document.querySelectorAll('.hero-slider__navigation .hero-nav__item'); // ヒーローナビのみ取得
    const validIndex = realIndex % navItems.length;
    console.log('Valid index:', validIndex);
    
    // 全てリセット
    resetAllProgress();

    // アクティブなアイテムを設定
    if (navItems[validIndex]) {
      navItems[validIndex].classList.add('hero-nav__item--active');
    }
  }

  // Swiperを初期化
  const swiper = new Swiper('.full-screen-slider', {
    direction: 'horizontal',
    loop: true,
    speed: 1000,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    // Lenis smooth scrollとの共存設定
    allowTouchMove: true,
    preventInteractionOnTransition: false,
    touchStartPreventDefault: false,
    on: {
      init: function() {
        console.log('Swiper initialized, realIndex:', this.realIndex);
        updateNavigation(this.realIndex);
        startProgressAnimation(this.realIndex);
      },
      slideChange: function() {
        console.log('Slide changed to realIndex:', this.realIndex);
        updateNavigation(this.realIndex);
        startProgressAnimation(this.realIndex);
      }
    }
  });

  // ナビゲーションクリックイベントを動的に設定
  function setupNavigationEvents() {
    const navItems = document.querySelectorAll('.hero-slider__navigation .hero-nav__item');
    navItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        console.log('Navigation clicked:', index);
        console.log('Current realIndex before click:', swiper.realIndex);
        
        // ループを考慮してslideToLoopを使用
        swiper.slideToLoop(index);
        
        // クリック後の状態をログ
        setTimeout(() => {
          console.log('After click - realIndex:', swiper.realIndex, 'activeIndex:', swiper.activeIndex);
        }, 100);
      });
    });
  }
  
  // ナビゲーションイベントを設定
  setupNavigationEvents();
});
